<div *ngIf="hasData">
  <p class="title">{{ proposals.titleMessage | translate }}</p>
  <app-momo-proposal-card
    [proposal]="proposals.preferences[0]"
    [proposalIndex]="1"
    [canEdit]="canEdit"
    (editClicked)="onActionClicked($event, 1)"
    (addProposalsClicked)="onAddProposalsClicked($event)"></app-momo-proposal-card>
  <app-momo-proposal-card
    [proposal]="proposals.preferences[1]"
    [proposalIndex]="2"
    [canEdit]="canEdit"
    (editClicked)="onActionClicked($event, 2)"
    (addProposalsClicked)="onAddProposalsClicked($event)"></app-momo-proposal-card>
  <app-observations-card
    [observations]="mappedObservations"
    [canEdit]="canEdit"
    (actionClicked)="onObservationsChanged($event)"
    *ngIf="canEdit || proposals.observations"></app-observations-card>
</div>
